export function generateBeyondBillingList() {
  return [
    {
      title: 'Queues',
      children: [
        { name: 'Overview', path: 'overview', icon: 'graph-mono' },
        {
          name: 'IncomeIQueue',
          path: 'income-i-queue',
          icon: 'note-text-1-mono',
          permission: 'is_admin'
        },
        { name: 'Payments', path: 'payments', icon: 'billing-mono', permission: 'payments.read' },
        {
          name: 'Patient Ledger',
          path: 'patient-ledger',
          icon: 'macro-mono',
          permission: 'payments.read'
        },
        // {
        //   name: 'Dynamic AR',
        //   path: 'dynamic-ar',
        //   icon: 'note-mono'
        // },
        { name: 'ERA', path: 'era-eob/era', icon: 'receipt-1-mono' },
        { name: 'EOB', path: 'era-eob/eob', icon: 'receipt-3-mono' },
        { name: 'Claims', path: 'claims', icon: 'wallet-mono' },
        {
          name: 'Superbills',
          path: 'superbills',
          icon: 'billing-mono',
          permission: 'superbill.read'
        },
        {
          name: 'Electronic Invoicing',
          path: 'electronic-invoicing',
          icon: 'file-invoice-mono',
          permission: 'invoicing.read'
        }
      ]
    },
    {
      title: 'Reports',
      path: 'reports',
      permission: 'reports.read',
      children: [
        { name: 'Standard Reports', path: 'standard', icon: 'chart-mono' },
        {
          name: 'Favorite Reports',
          path: 'favorite',
          icon: 'chart-favorite-mono'
        },
        { name: 'Custom Reports', path: 'custom', icon: 'chart-1-mono' }
      ]
    }
  ];
}
